export default {
  id: 'other-direct-costs',
  title: 'Other Direct Costs',
  category: 'Employee',
  summary: 'Request and track project- or customer-related direct costs that may be billable.',
  overview: 'Other Direct Costs (ODC) reports capture materials, supplies, and similar charges tied to a project or customer. Like general business, they often require approval before purchase.',
  howItWorks: [
    'Associate the request with the correct project or customer so costs land in the right place for billing and reporting.',
    'Add line items with estimates and submit for approval.',
    'After approval and purchase, enter actuals with receipts.',
    'Approved actuals may later appear in invoice or project cost workflows for administrators.'
  ],
  actions: [
    {
      name: 'Select project / customer',
      description: 'Links the costs to the correct billing and project structure.'
    },
    {
      name: 'Add line item',
      description: 'Adds a direct cost item with description and estimated amount.'
    },
    {
      name: 'Submit for approval',
      description: 'Sends the ODC request to reviewers. Purchasing before approval may violate company policy.'
    },
    {
      name: 'Enter actuals',
      description: 'Records final amounts and documentation after the cost is incurred.'
    }
  ],
  tips: [
    'Double-check the project association — incorrect linking causes billing and reporting issues.',
    'Keep descriptions clear so reviewers and invoice creators understand the charge.'
  ],
  related: ['expenses', 'expense-wizard', 'general-business', 'invoices']
};



// WEBPACK FOOTER //
// ./client/help/content/other-direct-costs.js